import { render, staticRenderFns } from "./PaChiefDeptRevenue.vue?vue&type=template&id=28ea50de&scoped=true"
import script from "./PaChiefDeptRevenue.vue?vue&type=script&lang=js"
export * from "./PaChiefDeptRevenue.vue?vue&type=script&lang=js"
import style0 from "./PaChiefDeptRevenue.vue?vue&type=style&index=0&id=28ea50de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea50de",
  null
  
)

export default component.exports